import { useNavigate } from "react-router-dom";
import { Lock, Crown, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";

export default function PaywallDialog({ open, onClose, reason, copy }) {
    const nav = useNavigate();
    if (!copy) return null;
    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="sm:max-w-md" data-testid={`paywall-dialog-${reason}`}>
                <DialogHeader>
                    <div className="mx-auto mb-2 w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center">
                        <Lock className="w-5 h-5 text-primary" />
                    </div>
                    <DialogTitle className="font-heading text-2xl font-normal text-center">
                        {copy.title}
                    </DialogTitle>
                    <DialogDescription className="text-center leading-relaxed">
                        {copy.body}
                    </DialogDescription>
                </DialogHeader>
                <div className="rounded-lg border border-border/60 bg-muted/40 px-4 py-3 flex items-center gap-3">
                    <Crown className="w-4 h-4 text-primary shrink-0" />
                    <div className="text-xs">
                        <div className="font-medium text-foreground/90">
                            Available on {copy.minPlan} and above
                        </div>
                        <div className="text-muted-foreground">
                            Cancel anytime — you keep access to the end of the billing period.
                        </div>
                    </div>
                </div>
                <DialogFooter className="sm:justify-between gap-2">
                    <Button variant="ghost" onClick={onClose} data-testid={`paywall-dismiss-${reason}`}>
                        Not now
                    </Button>
                    <Button
                        data-testid={`paywall-upgrade-${reason}`}
                        onClick={() => { onClose(); nav("/pricing"); }}
                        className="rounded-full"
                    >
                        <Sparkles className="w-4 h-4" /> See plans
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
